import React from 'react';
import {
  Box,
  Typography,
  Button,
  Container,
  Paper,
} from '@mui/material';
import {
  Home as HomeIcon,
  ArrowBack as ArrowBackIcon,
  Construction as ConstructionIcon,
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate('/dashboard');
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #d9ada3 0%, #eec3bb 50%, #fad1c9 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: 2,
      }}
    >
      <Container maxWidth="md">
        <Paper
          sx={{
            p: { xs: 4, md: 6 },
            textAlign: 'center',
            borderRadius: 3,
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
            background: 'rgba(255, 255, 255, 0.95)',
            backdropFilter: 'blur(10px)',
          }}
        >
          {/* Ícone de Construção */}
          <Box sx={{ mb: 3 }}>
            <ConstructionIcon
              sx={{
                fontSize: 80,
                color: '#ee44aa',
                '@keyframes pulse': {
                  '0%': { transform: 'scale(1)' },
                  '50%': { transform: 'scale(1.05)' },
                  '100%': { transform: 'scale(1)' },
                },
                animation: 'pulse 2s infinite',
              }}
            />
          </Box>

          {/* Título 404 */}
          <Typography
            variant="h1"
            component="h1"
            sx={{
              fontSize: { xs: '4rem', md: '6rem' },
              fontWeight: 'bold',
              color: '#ee44aa',
              mb: 2,
              textShadow: '2px 2px 4px rgba(0, 0, 0, 0.1)',
            }}
          >
            404
          </Typography>

          {/* Mensagem Principal */}
          <Typography
            variant="h4"
            component="h2"
            sx={{
              fontSize: { xs: '1.5rem', md: '2rem' },
              fontWeight: 600,
              color: '#333',
              mb: 2,
            }}
          >
            Ops! Página não encontrada
          </Typography>

          {/* Descrição */}
          <Typography
            variant="body1"
            sx={{
              fontSize: '1.1rem',
              color: '#666',
              mb: 1,
              maxWidth: 500,
              mx: 'auto',
            }}
          >
            A página que você está procurando pode não existir ou estar em construção.
          </Typography>

          <Typography
            variant="body2"
            sx={{
              color: '#888',
              mb: 4,
              fontStyle: 'italic',
            }}
          >
            Verifique o endereço digitado ou retorne à página inicial.
          </Typography>

          {/* Botões de Ação */}
          <Box
            sx={{
              display: 'flex',
              gap: 2,
              justifyContent: 'center',
              flexWrap: 'wrap',
            }}
          >
            <Button
              variant="contained"
              size="large"
              startIcon={<HomeIcon />}
              onClick={handleGoHome}
              sx={{
                px: 4,
                py: 1.5,
                backgroundColor: '#ee44aa',
                '&:hover': {
                  backgroundColor: '#d63384',
                  transform: 'translateY(-2px)',
                  boxShadow: '0 4px 12px rgba(238, 68, 170, 0.3)',
                },
                transition: 'all 0.3s ease',
              }}
            >
              Página Inicial
            </Button>

            <Button
              variant="outlined"
              size="large"
              startIcon={<ArrowBackIcon />}
              onClick={handleGoBack}
              sx={{
                px: 4,
                py: 1.5,
                borderColor: '#ee44aa',
                color: '#ee44aa',
                '&:hover': {
                  borderColor: '#d63384',
                  color: '#d63384',
                  backgroundColor: 'rgba(238, 68, 170, 0.05)',
                  transform: 'translateY(-2px)',
                },
                transition: 'all 0.3s ease',
              }}
            >
              Voltar
            </Button>
          </Box>

          {/* Informações Adicionais */}
          <Box
            sx={{
              mt: 4,
              pt: 3,
              borderTop: '1px solid rgba(0, 0, 0, 0.1)',
            }}
          >
            <Typography variant="body2" color="#666">
              Se você acredita que isso é um erro, entre em contato com o suporte.
            </Typography>
            <Typography variant="body2" color="#888" sx={{ mt: 1 }}>
              By Lust Lingerie - Sistema de Gestão
            </Typography>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};

export default NotFound;
